export default [
    {
        id: 1,
        name: 'SOAT'
    },
    {
        id: 2,
        name: 'Tecno'
    },
    {
        id: 3,
        name: 'Rodamiento'
    }
]
